import { Application } from 'pixi.js';
import { GAME_HEIGHT, GAME_WIDTH } from './config/tuning';
import { SceneManager } from './engine/scene-manager';
import { AudioBus } from './engine/audio';
import { setContext } from './engine/context';
import { installLetterboxFit } from './engine/resize';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { MenuScene } from './scenes/MenuScene';
import { DifficultyScene } from './scenes/DifficultyScene';
import { GameScene } from './scenes/GameScene';
import { GameOverScene } from './scenes/GameOverScene';
import { HighScoreScene } from './scenes/HighScoreScene';
import { TutorialScene } from './scenes/TutorialScene';
import { ShopScene } from './scenes/ShopScene';

async function bootstrap(): Promise<void> {
  const app = new Application();
  await app.init({
    // Transparent: the #bg-extended DIV behind the canvas provides the
    // room wall, so it fills the full viewport regardless of aspect ratio.
    backgroundAlpha: 0,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    antialias: true,
    autoDensity: true,
    resolution: Math.min(window.devicePixelRatio || 1, 2),
  });

  const host = document.getElementById('game');
  if (!host) throw new Error('Missing #game container');
  host.appendChild(app.canvas);

  installLetterboxFit(app, GAME_WIDTH, GAME_HEIGHT);

  const audio = new AudioBus();
  const sceneManager = new SceneManager(app);
  setContext({ app, sceneManager, audio });

  // Register all scene factories. Each scene is constructed fresh on start so
  // lifecycle cleanup is trivial (manager destroys the previous instance).
  sceneManager.register('BootScene', () => new BootScene());
  sceneManager.register('PreloadScene', () => new PreloadScene());
  sceneManager.register('MenuScene', () => new MenuScene());
  sceneManager.register('DifficultyScene', () => new DifficultyScene());
  sceneManager.register('GameScene', () => new GameScene());
  sceneManager.register('GameOverScene', () => new GameOverScene());
  sceneManager.register('HighScoreScene', () => new HighScoreScene());
  sceneManager.register('TutorialScene', () => new TutorialScene());
  sceneManager.register('ShopScene', () => new ShopScene());

  await sceneManager.start('BootScene');
}

void bootstrap();
